// 認証の内側にあるデータを取りに行く共通口。
//
// 実データ（プロトタイプ画面・相手先マスタ）は公開バンドルに置かない方針にした。
// バンドルは誰でも取得できるので、同梱＝公開と同じ意味になるため（2026-08-24）。
// 代わりに Pages Function がセッションを検証してから返す。ここはその呼び出し側。

import { supabase, supabaseReady } from './supabase.js'

export async function accessToken() {
  if (!supabaseReady) return ''
  const { data } = await supabase.auth.getSession()
  return (data && data.session && data.session.access_token) || ''
}

// 認証つき GET。失敗理由は呼び出し側が画面に出せるよう Error のメッセージに載せる。
export async function authedFetch(path) {
  const token = await accessToken()
  if (!token) throw new Error('サインインしてください')
  const base = import.meta.env.BASE_URL || '/'
  const res = await fetch(`${base}${path.replace(/^\//, '')}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (res.status === 401) throw new Error('社内アカウントでサインインしてください')
  if (!res.ok) throw new Error(`読み込みに失敗しました（${res.status}）`)
  return res
}

const cache = new Map() // path -> Promise<any>

// 同じものを何度も取りに行かない。失敗したらキャッシュから外して次回やり直せるようにする。
export function authedJson(path) {
  if (!cache.has(path)) {
    cache.set(path, authedFetch(path).then((r) => r.json()).catch((e) => { cache.delete(path); throw e }))
  }
  return cache.get(path)
}
